import './chosen-leasing-info.scss';

import { ChosenBankStatus, DocumentController } from '@/components/Shared/ui';
import warningIcon from '@/media/icons/warning-fill.png';

import { useSelectedOffer } from '../../../hooks';

const ChosenLeasingInfo: React.FC = () => {
  const { selectedOffer } = useSelectedOffer();

  const computedPaymentOrderFileUrl: string | null =
    selectedOffer?.status.code === 'financed'
      ? (selectedOffer.paymentOrderFileUrl ?? null)
      : null;

  const computedGuaranteeLetterFileUrl: string | null =
    selectedOffer?.guaranteeLetterFileUrl ?? null;

  return (
    <div className="ie-chosen-leasing-info">
      <div className="ie-chosen-leasing-info__header">
        <ChosenBankStatus
          img={selectedOffer?.leasingCompany.icon || warningIcon}
          name={selectedOffer?.leasingCompany.name || 'Лизинговая компания'}
          status={{
            code: selectedOffer?.status.code || '',
            name: selectedOffer?.status.name
          }}
          size="big"
        />
      </div>

      {!!computedPaymentOrderFileUrl && (
        <DocumentController
          fileLink={computedPaymentOrderFileUrl}
          title="Платежное поручение"
          oldDownloadMethod
          downloadable
          wrapperClassName="ie-chosen-leasing-info__documents"
        />
      )}

      {!!computedGuaranteeLetterFileUrl && (
        <DocumentController
          fileLink={computedGuaranteeLetterFileUrl}
          title="Гарантийное письмо"
          oldDownloadMethod
          downloadable
          wrapperClassName="ie-chosen-leasing-info__documents"
        />
      )}
    </div>
  );
};

export default ChosenLeasingInfo;
